import { useBackgroundJobs } from 'App/settings/jobs/hooks';

function useDeleteLocationJob() {
  const { jobStatus, jobData, removeJob, setJob } =
    useBackgroundJobs('deleteLocation');
  return {
    deletingLocationId:
      jobStatus === 'pending' ? (jobData?.locationId as string) : null,
    jobStatus,
    jobData,
    setJob,
    removeJob,
  };
}

export default useDeleteLocationJob;
